import home from '../home/routes';
import auth from '../auth/routes';

const routes = [
    auth,
    home
];

export default routes;